import RetailMediaReportV2 from './v2'

const RetailMediaReport = () => {
  return <RetailMediaReportV2 />
}

export default RetailMediaReport
